
import { Component, Vue, Ref } from 'vue-property-decorator'
import { IPublicReporterGroup, IMediaTag } from '@/types/media-types'
import { MediaService } from '@/services/index'
import mediaService from '@/services/media-service'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

const TIP_MSG = {
    CLEAR_ERROR: '请先选择媒体',
    CREATE_ERROR: '请选择正确的组合，至少选择两个媒体'
}

const STATUS = {
    CREATE: 'create',
    UPDATE: 'update'
}

@Component({
    components: {
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize: number = 10
    private pageTotal: number = 8
    private pageIndex: number = 1
    private createDialog: boolean = false
    private isValidatePass: boolean = true
    private tipMsg: string = TIP_MSG.CREATE_ERROR
    private mediaName: string = ''
    private status = STATUS.CREATE
    private modifyCombination!: IPublicReporterGroup
    private tableData: IPublicReporterGroup[] = []
    private mediaGroup: IMediaTag[] = []
    private loading: any
    private existMediaList: string[] = []

    private mounted() {
        this.getCombinationList()
    }

    private async getCombinationList() {
        this.showLoading('获取数据中')
        const params = {
            page_size: this.pageSize,
            page_index: this.pageIndex
        }
        const result = await MediaService.getCombinationList(params)
        this.closeLoading()
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.tableData = result.data.results
            this.existMediaList = this.flatMediaListToString(result.data.results)
            return
        }
        this.$message({ type: 'error', message: result.message })
    }

    private flatMediaListToString(list: any[]) {
        let flatList:any[] = []
        list.forEach(item => {
            const names = item.medium_list.map((medium: any) => medium.name)
            flatList.push(...names)
        })
        return flatList
    }

    private async getMediaList(queryString: string) {
        const params = { media_name: queryString, page_size: 10, page_index: 1 }
        const result = await mediaService.getList(params)
        if (result.status === 200) {
            return result.data.media_list 
        }
        return []
    }

    private afterDialogClose() {
        this.isValidatePass = true
        this.tipMsg = TIP_MSG.CREATE_ERROR
        this.mediaName = ''
        this.mediaGroup = []
    }
    private onCreate() {
        // 开始校验
        if (this.mediaGroup.length < 2) {
            this.isValidatePass = false
            return this.tipMsg = TIP_MSG.CREATE_ERROR
        }
        this.createDialog = false
        const text = this.status === STATUS.CREATE ? '创建中' : '修改中'
        this.showLoading(text)
        if (this.status === STATUS.CREATE) {
            this.addCombination()
        } else if (this.status === STATUS.UPDATE) {
            this.updateCombination()
        }
    }
    private async addCombination() {
        const params = { media_list: this.mediaGroup }
        const result = await mediaService.addCombination(params)
        this.closeLoading()
        if (result.status === 200) {
            this.$message({ showClose: true, type: 'success', message: '添加组合成功' })
            return this.getCombinationList()
        }
        this.$message({ type: 'error', message: result.message })
    }

    private async updateCombination() {
        const params = { id: this.modifyCombination.id, media_list: this.mediaGroup }
        const result = await mediaService.updateCombination(params)
        this.closeLoading()
        if (result.status === 200) {
            this.$message({ showClose: true, type: 'success', message: '修改组合成功' })
            return this.getCombinationList()
        }
        this.$message({ type: 'error', message: result.message })
    }

    private onCloseMediaTag(media: IMediaTag, index: number) {
        this.mediaGroup.splice(index, 1)
    }

    private onClearInput() {
        if (!this.mediaName) {
            this.isValidatePass = false
            this.tipMsg = TIP_MSG.CLEAR_ERROR
            return
        }
        this.isValidatePass = true
        this.mediaName = ''
    }

    private onInputSelect(item: IMediaTag) {
        for (let media of this.mediaGroup) {
            if (media.id === item.id) {
                return this.$mwarning('请勿重复选择')
            }
        }
        this.mediaGroup.push(item)
    }

    private async querySearch(queryString: string, cb: Function) {
        const suggestions = await this.getMediaList(queryString)
        const suggestionList = suggestions.map((suggestion: any) => ({ id: suggestion.id, name: suggestion.name }))
        cb(suggestionList)
    }

    private onCurrentChange(currPage: number) {
        this.pageIndex = currPage
        this.scrollEl.scrollToTop(this.getCombinationList)
    }

    private onCreateGroup() {
        this.status = STATUS.CREATE
        this.createDialog = true
    }
    private onEdit(combination: any) {
        this.status = STATUS.UPDATE
        this.modifyCombination = JSON.parse(JSON.stringify(combination))
        this.mediaGroup = this.modifyCombination.medium_list
        this.createDialog = true
    }

    private onRemove(id: number) {
        this.$confirm('你是否确定删除这个组合?', '确定', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.showLoading('删除中')
            const result = await mediaService.deleteCombination({ id })
            this.closeLoading()
            if (result.status === 200) {
                this.$message({ showClose: true, type: 'success', message: '删除成功!' })
                return this.getCombinationList()
            }
            this.$message({ type: 'error', message: result.message })
        })
    }

    private showLoading(text: string = '请稍等') {
        this.loading = this.$loading({
            lock: true,
            target: '.app-container.public-repoter',
            text: text
        })
    }

    private closeLoading() {
        this.loading && this.loading.close()
    }
}
